export const NONE_ID = "(none)";

export const FILTER_KEYS = ["source", "medium", "campaign", "content"];

export const EMPTY_FILTERS = {
  source: "",
  medium: "",
  campaign: "",
  content: "",
};

export const dimId = (value) => {
  const v = String(value ?? "").trim();
  return v || NONE_ID;
};

export const conversionRate = (landings, signups) => {
  const l = Number(landings) || 0;
  const s = Number(signups) || 0;
  if (!l) return 0;
  return Math.round((s / l) * 1000) / 1000;
};

export const formatConversion = (landings, signups) => {
  if (!landings) return "—";
  return `${Math.round((signups / landings) * 1000) / 10}%`;
};

export const hasActiveFilters = (filters = {}) =>
  FILTER_KEYS.some((key) => Boolean(filters[key]));

export const rowMatchesFilters = (row, filters = {}, skipKey = "") =>
  FILTER_KEYS.every((key) => {
    if (key === skipKey) return true;
    const wanted = filters[key];
    if (!wanted) return true;
    return dimId(row?.[key]) === wanted;
  });

export const filtersFromRow = (row) => ({
  source: dimId(row?.source),
  medium: dimId(row?.medium),
  campaign: dimId(row?.campaign),
  content: dimId(row?.content),
});

export const rowIsIsolated = (row, filters = {}) =>
  FILTER_KEYS.every(
    (key) => Boolean(filters[key]) && dimId(row?.[key]) === filters[key],
  );

const sortDimItems = (map) =>
  [...map.values()]
    .map((item) => ({
      ...item,
      conversion: conversionRate(item.landings, item.signups),
    }))
    .sort((a, b) => b.landings + b.signups - (a.landings + a.signups));

export const aggregateTrackRows = (rows, filters = {}, skipKey = "") => {
  const matched = (rows || []).filter((row) =>
    rowMatchesFilters(row, filters, skipKey),
  );
  const totals = { landings: 0, signups: 0, conversion: 0 };
  const maps = {
    source: new Map(),
    medium: new Map(),
    campaign: new Map(),
    content: new Map(),
  };

  const bump = (map, id, row) => {
    if (!map.has(id)) {
      map.set(id, { id, landings: 0, signups: 0 });
    }
    const entry = map.get(id);
    entry.landings += Number(row.landings) || 0;
    entry.signups += Number(row.signups) || 0;
  };

  matched.forEach((row) => {
    totals.landings += Number(row.landings) || 0;
    totals.signups += Number(row.signups) || 0;
    bump(maps.source, dimId(row.source), row);
    bump(maps.medium, dimId(row.medium), row);
    bump(maps.campaign, dimId(row.campaign), row);
    bump(maps.content, dimId(row.content), row);
  });

  totals.conversion = conversionRate(totals.landings, totals.signups);

  return {
    rows: matched,
    totals,
    bySource: sortDimItems(maps.source),
    byMedium: sortDimItems(maps.medium),
    byCampaign: sortDimItems(maps.campaign),
    byContent: sortDimItems(maps.content),
  };
};
